/**
 * Component used for downsizing images.
 * Project: 4gewinnt
 * Created: 2019-06-27
 */

/**
 *
 * @param imageDataObject
 * @returns {Promise<any>}
 */
function resizeImageDataObject(imageDataObject) {
  let image = new Image();
  image.src = imageDataObject.imageData;

  return new Promise(function(resolve,reject){
    image.onload = function() {
      imageDataObject.imageData = resizeHelperImage(this);
      resolve(imageDataObject.imageData);
    };
    image.onerror = function(){
      reject( Error("Bild konnte nicht geladen werden!") );
    };
  });
}

/**
 * Resizes ...
 * @param img
 * @returns {string}
 */
function resizeHelperImage(img){
  var canvas = document.createElement('canvas');
  var width = img.width;
  var max_width = 1000;
  var height = img.height;
  var max_height = 1000;
  // calculate the width and height, constraining the proportions
  // default: maximize width
  height = Math.round(height *= max_width / width);
  width = max_width;
  if (height > max_height) {
    // maximize height
    width = Math.round(width *= max_height / height);
    height = max_height;
  }
  // resize the canvas and draw the image data into it
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  // preview.appendChild(canvas); // do the actual resized preview
  return canvas.toDataURL("image/jpeg",0.7);
}


export { resizeImageDataObject as default };
